import React from 'react';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const navigate = useNavigate();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/');
  };

  return (
    <div className="flex flex-col h-full min-h-[80vh] items-center justify-center p-4">
      <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 ring-1 ring-primary/30">
        <span className="material-symbols-outlined text-4xl text-primary">workspaces</span>
      </div>
      
      <h1 className="mb-2 text-2xl font-bold text-white">Welcome Back</h1>
      <p className="mb-8 text-center text-white/60">Enter your credentials to access your account.</p>

      <form onSubmit={handleLogin} className="w-full max-w-sm space-y-4">
        <div className="space-y-1">
          <input 
            type="email" 
            className="w-full rounded-xl bg-white/5 border border-white/10 p-4 text-white placeholder-white/30 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all"
            placeholder="Email Address"
            defaultValue="guest@vip-coworking.com"
          />
        </div>
        
        <div className="space-y-1">
          <input 
            type="password" 
            className="w-full rounded-xl bg-white/5 border border-white/10 p-4 text-white placeholder-white/30 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all"
            placeholder="Password"
            defaultValue="password123"
          />
        </div>

        <div className="flex justify-end">
          <button type="button" className="text-sm text-primary hover:underline">Forgot Password?</button>
        </div>

        <button 
          type="submit"
          className="mt-6 w-full rounded-full bg-primary p-4 font-bold text-black shadow-xl shadow-primary/20 transition-all hover:bg-primary/90 active:scale-95"
        >
          Sign In
        </button>
      </form>
      
      <p className="mt-8 text-sm text-white/60">
        Don't have an account? <span className="cursor-pointer font-bold text-primary hover:underline">Apply for Membership</span>
      </p>
    </div>
  );
};

export default Login;